<template>
  <div class="tw:text-center tw:relative tw:h-full tw:w-full tw:md:min-w-[142px]">
    <div
      class="tw:rounded-xl tw:shadow-mdLg tw:relative tw:h-full tw:border-2 box-border tw:w-full tw:hover:bg-blue-100"
      :data-testid="`commission-level-card-${commissionValue}`"
      :class="{
        'tw:bg-blue-100 tw:border-blue-700 ': isSelected,
        'tw:border-transparent tw:bg-white': !isSelected && !isRecommended,
      }"
    >
      <div class="tw:flex tw:flex-col">
        <div
          :class="
            isChangingCampaign ? 'tw:flex-row tw:py-3 tw:px-8' : 'tw:md:flex-col tw:flex-row tw:py-3 tw:px-8 tw:md:py-6'
          "
          class="tw:flex tw:items-center tw:w-full"
        >
          <div
            aria-hidden="true"
            class="tw:flex tw:items-center tw:justify-center tw:rounded-full tw:h-4 tw:w-4 tw:border"
            :class="radioButtonClasses"
          >
            <div
              class="tw:rounded-full tw:h-2 tw:w-2 tw:border tw:border-blue-800 tw:bg-white"
              :class="isSelected ? 'tw:block' : 'tw:hidden'"
            />
          </div>
          <h5 class="tw:font-bold tw:text-3xl" :class="{ 'tw:md:mt-6 tw:md:mb-5': !isChangingCampaign }">
            {{ `${commissionValue}%` }}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  isChangingCampaign: Boolean,
  isSelected: {
    type: Boolean,
    default: false,
  },
  commissionValue: {
    type: Number,
    required: true,
    default: 0,
  },
})

const radioButtonClasses = computed(() => {
  const classes = []
  if (props.isChangingCampaign) classes.push('tw:mr-6')
  else classes.push('tw:mr-6 tw:md:mr-0')
  if (props.isSelected) classes.push('tw:border-blue-800 tw:bg-blue-500')
  else classes.push('tw:border-gray-500 tw:bg-transparent ')
  return classes.join(' ')
})
</script>
